import { MailCheck, MailWarning, MailX } from "lucide-react";

const REASON = {
  sending_disabled: "l'invio delle email è spento in questo ambiente: manda tu il link",
  recipient_not_allowlisted: "l'indirizzo non è tra quelli di prova autorizzati: manda tu il link",
  missing_api_key: "il servizio email non è ancora configurato: manda tu il link",
  missing_sender: "il mittente non è ancora configurato: manda tu il link",
  provider_temporary_error: "servizio email momentaneamente non disponibile: manda tu il link",
  provider_rejected: "il servizio email ha rifiutato il messaggio: manda tu il link",
  internal_error: "errore interno nella preparazione dell'email: manda tu il link",
};
const ST = {
  dry_run: ["Email in prova, non inviata", "text-amber-700", MailWarning],
  sent: ["Email inviata", "text-emerald-700", MailCheck],
  error: ["Email non inviata", "text-red-700", MailX],
};

const NONE = ["Esito email non disponibile", "text-slate-500", MailWarning];

export const emailNote = (d) => (d ? `${(ST[d.status] || ST.error)[0]}${d.reason ? `: ${REASON[d.reason] || "manda tu il link"}` : ""}` : "");

// Masked recipient + delivery outcome of the MUSORA invite email (never the full address or the link).
export function InviteEmailStatus({ invite }) {
  const d = invite.email_delivery;
  const [label, tone, Icon] = d ? ST[d.status] || ST.error : NONE;
  return (
    <p className={`flex w-full min-w-0 items-start gap-1.5 text-[11px] leading-4 ${tone}`} data-testid={`invite-email-${invite.id}`}>
      <Icon size={13} className="mt-px shrink-0" aria-hidden="true" />
      <span className="min-w-0 break-words">
        <span className="font-medium text-slate-700" data-testid={`invite-email-masked-${invite.id}`}>{invite.email_masked}</span>
        {" · "}<span data-testid={`invite-email-status-${invite.id}`}>{label}</span>
        {d?.reason && <span className="text-slate-500"> ({REASON[d.reason] || "manda tu il link"})</span>}
      </span>
    </p>
  );
}
